<script lang="ts">
    import type { UserData } from "@anyways-open/identity-api-client";
    import { appManager } from "../../AppManagerStore";

    export let data: UserData;

    let firstName = data.firstName;
    let lastName = data.lastName;

    const onSave = async () => {
        const accessToken = await $appManager.Authenticator.getAccessToken();
        await $appManager.IdentityApi.postUser({
            accessToken: accessToken,
            data: {
                firstName: firstName,
                lastName: lastName,
            },
            id: data.id,
        });

        data.firstName = firstName;
        data.lastName = lastName;
    };
</script>

<div class="card card-bleed shadow-light-lg mb-6">
    <div class="card-header">
        <h4 class="mb-0">Basic Information</h4>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label class="form-label" for="firstname">First Name</label>
                    <input
                        class="form-control"
                        id="firstname"
                        type="text"
                        placeholder="First Name"
                        bind:value={firstName} />
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label class="form-label" for="lastname">Last Name</label>
                    <input
                        class="form-control"
                        id="lastname"
                        type="text"
                        placeholder="Last Name"
                        bind:value={lastName} />
                </div>
            </div>
            <div class="col-12 col-md-auto">
                <button
                    class="btn w-100 btn-primary"
                    on:click={async () => await onSave()}>
                    Save changes
                </button>
            </div>
        </div>
    </div>
</div>
